import {FreeTrialPeriodFragment} from '../../../../gql/graphql';
import {SubscriptionFrequency, toSubscriptionFrequency} from './SubscriptionSettings.model';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class FreeTrialPeriodModel {
  public frequency: SubscriptionFrequency;
  public interval?: number;

  constructor(params: FreeTrialPeriodModel) {
    this.frequency = params.frequency;
    this.interval = params.interval;
  }

  public static fromCheckoutV1(freeTrialPeriod?: FreeTrialPeriodFragment | null) {
    return new FreeTrialPeriodModel({
      frequency: toSubscriptionFrequency(freeTrialPeriod?.frequency),
      interval: mapNullToUndefined(freeTrialPeriod?.interval),
    });
  }
}
